export const DRAWER_W = 240;
export const COLLAPSED_W = 60;
export const SIDEBAR_STORAGE_KEY = 'adminSidebarOpen';
